module.exports = __webpack_public_path__ + "img/category-header.05c579d8.png";